import React from 'react';
import { ContentLayout } from 'layout/content';
import { DossierOccupantsContainer } from 'pods/dossier/occupants';
export const DossierOccupantsScene = () => {
    return (React.createElement(ContentLayout, null,
        React.createElement(DossierOccupantsContainer, null)));
};
